export default {"src":"/uk/_next/static/media/spot-verify-identity.0da1ba83.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};